var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"spreadsheet-toggle",attrs:{"data-cy":"spreadsheet-toggle","title":"Open the current selection as an editable spreadsheet"},on:{"click":_vm.open}},[_c('mdi',{attrs:{"table":""}}),_c('span',[_vm._v("Sheet")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }